import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debug } from 'console';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ScadenzaAdapter } from 'src/app/common/components/fascicolo/scadenzario-update/scadenza-adapter';
import { BaseForm } from 'src/app/common/form/base-Form';
import { Scadenza } from 'src/app/common/models/scadenza';
import { MotivoScadenzaAuto } from 'src/app/common/models/tipologiche/motivo-scadenza-auto';
import { Priorita } from 'src/app/common/models/tipologiche/priorita';
import { TipoScadenza } from 'src/app/common/models/tipologiche/tipo-scadenza';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { CreazionePraticaTipologicheService } from '../../../../services/creazione-pratica-tipologiche.service';
import { Subject } from 'rxjs';
import { Motivo } from 'src/app/common/models/tipologiche/motivo';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-step-adempimenti-form',
  templateUrl: './step-adempimenti-form.component.html',
  styleUrls: ['./step-adempimenti-form.component.css']
})
export class StepAdempimentiFormComponent implements OnInit, OnDestroy {

  PropertiesSettings: PropertiesSettings;
  public scadenzaForm: FormGroup;
  scadenza: Scadenza;
  public ora: string;
  public oraSet: string;
  public minSet: string;

  public tipoScadenzaOptions: TipoScadenza[] = [];
  public motivoScadenzaOptions: MotivoScadenzaAuto[] = [];
  public prioritaOptions: Priorita[] = [];

  motivoScadenzaOptionsFiltrate: MotivoScadenzaAuto[] = [];

  private componentDestroyed$: Subject<void> = new Subject<void>();
  motivoEvasioneOptions: Motivo[] = [];

  @Output() adempimentoChange: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();

  constructor(private campiForm: FormBuilder, private tipologicheService: CreazionePraticaTipologicheService, private creazionePraticaStore: CreazionePraticaStoreService,private helpers: HelpersService,) {
    this.populateSelect();
    this.createForm();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(){
    this.componentDestroyed$.next();
  }

  createForm() {
    this.oraSet = "00";
    this.minSet = "00";
    this.ora = this.oraSet+":"+this.minSet;
    this.scadenzaForm = this.campiForm.group({
      tipoScadenza: [null, Validators.required],
      motivo: [null, Validators.required],
      priorita: [null, Validators.required],
      dataScadenza: [null, Validators.required],
      dataPromemoria: [null],
      pubblica: [true],
      evasa: [false],
      dataEvasione: [{value: null, disabled: true}],
      motivoEvasione: [null],
      appunto: [null],
      note: [null]
    });
    this.scadenzaForm.get('tipoScadenza').valueChanges.pipe(distinctUntilChanged()).subscribe(value => this.onChangeTipoScadenza(value));
    this.scadenzaForm.get('evasa').valueChanges.pipe(distinctUntilChanged()).subscribe(value =>
        value ? this.scadenzaForm.get('dataEvasione').enable() : this.scadenzaForm.get('dataEvasione').disable()
      );
  }

  submit() {
    if(this.scadenzaForm.valid){
      this.scadenza = this.scadenzaForm.getRawValue();
      let date = new Date(this.scadenza.dataScadenza);
      let oraMinuti: string[] = this.ora.split(':');
      date.setHours(Number(oraMinuti[0]), Number(oraMinuti[1]));
      this.scadenza.dataScadenza = date.getTime();
      this.adempimentoChange.emit(this.scadenza);
    }
  }

  onChangeTipoScadenza(event: TipoScadenza){
      this.scadenzaForm.get('tipoScadenza').setValue(event);
      this.scadenzaForm.get('motivo').setValue(null);

      if(event){
          this.motivoScadenzaOptionsFiltrate = this.motivoScadenzaOptions.filter(scadenza => scadenza.tipoScadenza.id == event.id);
      }
      else{
          this.motivoScadenzaOptionsFiltrate = this.motivoScadenzaOptions;
      }
  }

  populateSelect(){
    this.tipologicheService.getTipiScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.tipoScadenzaOptions = response;
      /*
      LOGICA PER MOSTRARE IL TIPO D'ADEMPIMENTO INCONTRO CGS, REINSTATARE AD IMPLEMENTAZIONE COMPLETA DEL TIPO
      if(this.creazionePraticaStore.getTipoFascicolo() != null && this.creazionePraticaStore.getTipoFascicolo().label != "SINISTRO SANITARIO")
        this.tipoScadenzaOptions = response.filter(el => el.id != 'INCONTRO');
      else
        this.tipoScadenzaOptions = response;*/
      // this.tipoScadenzaOptions = response.filter(el => el.id != 'INCONTRO');
    });
    this.tipologicheService.getPrioritaScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => this.prioritaOptions = response);
    this.tipologicheService.getMotivoScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.motivoScadenzaOptions = response;
      this.motivoScadenzaOptionsFiltrate = response;
    });
    this.helpers.getMotiviEvadiScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => this.motivoEvasioneOptions = response);
  }

  onEvasa(event) {
    this.scadenzaForm.get('evasa').setValue(event);
    this.scadenzaForm.get('motivoEvasione').setValue(null);
    this.scadenzaForm.get('dataEvasione').setValue(null);
    if(event) {
      this.scadenzaForm.get('dataEvasione').setValidators([Validators.required]);
    } else {
      this.scadenzaForm.get('dataEvasione').setValidators([]);
    }
    // this.scadenza.evasa = event; 
    // this.scadenza.dataEvasione = null
    // this.scadenza.motivoEvasione = null;
  }

}
